export default __webpack_public_path__ + "static/media/90s_button_rectangle.8183f407.svg";